module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "site-footer"
    }
  }, [_c('div', {
    staticClass: "site-links"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/TermsAndConditions"
    }
  }, [_vm._v("Terms")])], 1), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/PrivacyPolicy"
    }
  }, [_vm._v("Privacy")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    attrs: {
      "href": "https://www.stormgardenstudio.com",
      "target": "_blank"
    }
  }, [_vm._v("Copyright © 2020 Storm Garden Studio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Develteam/"
    }
  }, [_c('i', {
    staticClass: "fab fa-facebook"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    attrs: {
      "href": "https://twitter.com/Develteam"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-db680340!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layouts/LayoutFooter.vue
// module id = 922
// module chunks = 2